import Layout from "@/components/layout/Layout";
import SEO from "@/components/SEO";

const Privacy = () => {
  return (
    <Layout>
      <SEO title="Privacy Policy · Soft Chaos Studio" description="Privacy policy for Soft Chaos Studio." canonical="/privacy" />
      <section className="container py-16 max-w-3xl mx-auto">
        <h1 className="text-4xl font-serif font-semibold mb-8">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: March 2026</p>

        <div className="prose prose-sm max-w-none space-y-6 text-foreground">
          <div>
            <h2 className="font-serif text-xl font-semibold mb-3">1. What Data We Collect</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              We may collect the following personal information when you use our website or services:
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground mt-2 space-y-1">
              <li>Full name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Details of your gift request or enquiry</li>
              <li>Any images or files you upload</li>
              <li>IP address and browser information (via cookies)</li>
            </ul>
          </div>

          <div>
            <h2 className="font-serif text-xl font-semibold mb-3">2. Why We Collect It</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              We collect your data to respond to enquiries, process quote requests, fulfil orders, send updates about your order, and improve our services. We will never sell your data to third parties.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-xl font-semibold mb-3">3. How We Store Your Data</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Your data is stored securely using industry-standard encryption. We retain your personal data only for as long as necessary to fulfil the purposes outlined in this policy, or as required by law.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-xl font-semibold mb-3">4. Third-Party Tools</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              We may use the following third-party tools to operate our business:
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground mt-2 space-y-1">
              <li>Email service providers for communication</li>
              <li>GoHighLevel for CRM and marketing (if applicable)</li>
              <li>Payment processors for transactions</li>
              <li>Analytics tools to understand website usage</li>
            </ul>
          </div>

          <div>
            <h2 className="font-serif text-xl font-semibold mb-3">5. Cookies</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Our website may use cookies to improve your browsing experience and to analyse traffic. You can control cookie preferences through your browser settings. Essential cookies are required for the website to function properly.
            </p>
          </div>

          <div>
            <h2 className="font-serif text-xl font-semibold mb-3">6. Your Rights Under UK GDPR</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Under the UK General Data Protection Regulation (UK GDPR), you have the following rights:
            </p>
            <ul className="list-disc list-inside text-sm text-muted-foreground mt-2 space-y-1">
              <li>The right to access your personal data</li>
              <li>The right to rectification of inaccurate data</li>
              <li>The right to erasure ("right to be forgotten")</li>
              <li>The right to restrict processing</li>
              <li>The right to data portability</li>
              <li>The right to object to processing</li>
            </ul>
          </div>

          <div>
            <h2 className="font-serif text-xl font-semibold mb-3">7. Contact Us</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              If you have any questions about this privacy policy or wish to exercise your data rights, please contact us at:
            </p>
            <p className="text-sm text-muted-foreground mt-2">
              <strong>Email:</strong> softchaos.uk@gmail.com
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Privacy;
